import { Button, Result } from 'antd';
import { useRouter } from '@/hooks/hooks';
import style from './Common.module.less';

const NoPermission = () => {
  const router = useRouter();
  return (
    <div className={style.noPermissionWrapper}>
      <Result
        status="403"
        title="403"
        subTitle="对不起，您没有权限打开这个页面"
        extra={<Button onClick={() => router.back()} type="primary">返回</Button>}
      />
    </div>
  );
};

export default NoPermission;